<template>
  <div class="seminar customScroll">
    <v-card class="px-10 pt-5" flat>
      <div class="d-flex justify-space-between">
        <span style="font-size: 24px"><b>Edit Seminar</b></span>
        <v-icon @click="close()">mdi-close</v-icon>
      </div>
    </v-card>
    <v-card class="px-10" flat color="#E5E5E5">
      <div>
        <div class="d-flex justify-center mt-4">
          <span class="mt-4"> <b> Type</b></span>
        </div>
        <div class="pa-6">
          <div class="slide-toggle d-flex">
            <div class="boxes" @click="form.Type = 1">In-Person</div>
            <div class="boxes" @click="form.Type = 2">Online</div>
            <div
              class="box-active animated"
              :class="{ 'presential-active': form.Type == 2 }"
            ></div>
          </div>
        </div>
        <div class="mt-9">
          <v-select
            class="my-8 mb-0"
            label="Select Course"
            attach
            single-line
            dense
            hide-details
            :items="visibleCourses"
            item-text="Title"
            item-value="Id"
            v-model="form.CourseId"
          ></v-select>
          <v-select
            class="mt-8 mb-3 mb-0"
            label="Select Instructor"
            attach
            :items="InstructorsArray"
            item-value="Id"
            item-text="Name"
            single-line
            dense
            hide-details
            @change="getLocations(form.InstructorId)"
            v-model="form.InstructorId"
          ></v-select>
          <v-select
            :items="acceptedInstructorsCoordinator"
            label="Select Coordinator"
            attach
            item-value="Coordinator.Id"
            item-text="Coordinator.fullName"
            single-line
            hide-details
            class="mb-3 mt-4"
            v-model="form.CoordinatorId"
          ></v-select>
          <!-- <div class="d-flex justify-end mt-4">
            <v-btn
              class="text--transformation"
              link
              text
              color="primary"
              to="/coordinators"
              >+ Add new Coordinator</v-btn
            >
          </div> -->
          <!-- <div class="d-flex justify-end mt-4">
            <v-btn
              class="primary--text text--transformation"
              link
              text
              color="primary"
              to="/location"
              >+ Add new Location</v-btn
            >
          </div> -->

          <v-select
            :items="filterLanguageList"
            label="Language"
            attach
            single-line
            hide-details
            class="my-2"
            v-model="form.Languages"
          ></v-select>
          <v-select
            :items="StatusArray"
            label="Status"
            attach
            single-line
            hide-details
            class="my-2"
            v-model="form.Status"
          ></v-select>
          <div class="d-flex align-center" v-if="form.Type === 1">
            <div class="mr-5" style="color: #727070">
              Is the seminar also available online?
            </div>
            <v-radio-group row class="d-flex align-center mt-0" v-model="form.AvailableOnline">
              <span style="color: #727070" class="mt-4"> Yes</span>
              <v-radio :value="true" class="mx-2 mr-7 mt-4"></v-radio>
              <span style="color: #727070" class="mt-4"> No </span>
              <v-radio :value="false" class="mx-2 mt-4"></v-radio>
            </v-radio-group>
          </div>
          <div class="mt-7"><b>Payment Details</b></div>
          <v-row>
            <v-col cols="6">
              <v-text-field
                label=" Full Price"
                single-line
                class="my-2"
                v-model="form.FullPrice"
                type="number"
                :error-messages="
                  getErrorMessagesFullPrice(form.FullPrice)
                "
              ></v-text-field>
            </v-col>
            <v-col cols="6">
              <v-select
                :items="GetCurrencies"
                label="Currency"
                attach
                class="my-2"
                single-line
                hide-details
                item-value="Id"
                item-text="CurrencyCode"
                v-model="form.CurrencyId"
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="pt-0">
              <v-text-field
                label=" Early bird price"
                single-line
                class="my-2"
                :disabled="form.FullPrice == 0 && form.FullPrice !== ''"
                v-model="form.EarlyBirdPrice"
                type="number"
                :error-messages="getErrorMessagesEarlyBirdPrice(form.EarlyBirdPrice)"
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="pt-0">
              <v-menu
                v-model="CalanderEarlyBirdEndTime"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                attach
                :nudge-right="-40"
                :nudge-top="20"
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.EarlyBirdEndTime"
                    label=" Early bird end date"
                    append-icon="mdi-calendar-range-outline"
                    readonly
                    :disabled="form.FullPrice == 0 && form.FullPrice !== ''"
                    v-bind="attrs"
                    class="mt-2"
                    single-line
                    v-on="on"
                    clearable
                  ></v-text-field>
                </template>
                <v-date-picker
                  no-title
                  v-model="form.EarlyBirdEndTime"
                  @input="CalanderEarlyBirdEndTime = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
          </v-row>
          <div class="d-flex align-center">
            <div class="mr-5" style="color: #727070">Show Monitor Rate(s)</div>
            <v-radio-group
              row
              class="d-flex align-center mt-0"
              v-model="form.MonitorRate"
            >
              <span style="color: #727070" class="mt-4"> Yes</span>
              <v-radio :value="true" class="mx-2 mr-7 mt-4"></v-radio>
              <span style="color: #727070" class="mt-4"> No </span>
              <v-radio :value="false" class="mx-2 mt-4"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex align-center">
            <div class="mr-5" style="color: #727070">
              Auto Graduate on Payment
            </div>
            <v-radio-group
              v-model="form.AutoPayment"
              row
              class="d-flex align-center mt-0"
            >
              <span style="color: #727070" class="mt-4"> Yes</span>
              <v-radio :value="true" class="mx-2 mr-7 mt-4"></v-radio>
              <span style="color: #727070" class="mt-4"> No </span>
              <v-radio :value="false" class="mx-2 mt-4"></v-radio>
            </v-radio-group>
          </div>
          <div class="d-flex align-center">
            <div class="mr-5" style="color: #727070">IBA Payment</div>
            <v-radio-group
              v-model="form.IbaPayment"
              row
              class="d-flex align-center mt-0"
            >
              <span style="color: #727070" class="mt-4"> Yes</span>
              <v-radio :value="true" class="mx-2 mr-7 mt-4"></v-radio>
              <span style="color: #727070" class="mt-4"> No </span>
              <v-radio :value="false" class="mx-2 mt-4"></v-radio>
            </v-radio-group>
          </div>
          <v-text-field
            label="Payment Link (Optional and only if there is no payment to IBA)"
            single-line
            dense
            v-show="form.IbaPayment"
            hide-details
            class="py-4"
            v-model="form.PaymentLink"
          ></v-text-field>
          <v-text-field
            label="Primary Payment Link (Optional)"
            v-model="form.PrimaryPaymentLink"
            single-line
            dense
            @click="InstructorRegisterDialog = true"
            class="py-4"
          ></v-text-field>
          <v-text-field
            label="Repeat Standard Student/Monitor Payment Link (Optional)"
            v-model="form.RepeatStandardStudentPaymentLink"
            single-line
            dense
            class="py-4"
            :error-messages="
              $v.form.RepeatStandardStudentPaymentLink.$error 
                ? 'Alternate payment links cannot be added unless a Primary Payment link is added first.' 
                : ''
            "
          ></v-text-field>
          <v-text-field
            label="Repeat Practitioner Student/Monitor Payment Link (Optional)"
            v-model="form.RepeatPractitionerStudentPaymentLink"
            single-line
            dense
            class="py-4"
            :error-messages="
              $v.form.RepeatPractitionerStudentPaymentLink.$error 
                ? 'Alternate payment links cannot be added unless a Primary Payment link is added first.' 
                : ''
            "
          ></v-text-field>
          <v-text-field
            label="Early Bird Payment Link (Optional)"
            v-model="form.EarlyBirdPaymentLink"
            single-line
            dense
            class="py-4"
            :error-messages="
              $v.form.EarlyBirdPaymentLink.$error 
                ? 'Alternate payment links cannot be added unless a Primary Payment link is added first.' 
                : ''
            "
          ></v-text-field>

          <div class="mt-6 mb-8"><b>Seminar Dates and Times</b></div>
          <v-select
            class="mt-2 mb-5"
            label="Select Location "
            attach
            single-line
            dense
            :items="GetLocation.List"
            hide-details
            item-text="LocationName"
            item-value="Id"
            v-model="form.Location"
            v-if="form.Type === 1"
          ></v-select>
          <v-autocomplete
            class="mt-2 mb-5"
            label="Select Time Zone "
            attach
            single-line
            dense
            hide-details
            item-text="name"
            item-value="timezone"
            :items="AllTimeZone"
            :filter="customFilter"
            v-model="form.Timezone"
            v-if="form.Type === 2"
          ></v-autocomplete>
          <div>
            <!------------------Start----------Date time section---------------------------------------------->

            <div
              v-for="(Date, index) in form.SeminarDates"
              :key="index"
              :DivSeminarDateTime="(DivSeminarDateTime = index)"
            >
              <v-row class="my-1">
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    ref="dateAt"
                    v-model="Date.dated"
                    attach
                    :close-on-content-click="false"
                    :return-value.sync="date"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="Date.Date"
                        label="Date at"
                        append-icon="mdi-calendar-range-outline"
                        readonly
                        v-bind="attrs"
                        hide-details
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="Date.Date"
                      no-title
                      scrollable
                      @change="Date.dated = false"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="Date.dated = false">
                        Cancel
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    ref="Date.times"
                    v-model="Date.times"
                    attach
                    :close-on-content-click="false"
                    :nudge-top="20"
                    :return-value.sync="StartTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedStartTime(Date.StartTime)"
                        label="Time Start"
                        append-icon="mdi-calendar-range-outline"
                        readonly
                        single-line
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <!-- <v-time-picker
                      v-if="Date.times"
                      v-model="Date.StartTime"
                      full-width
                      @change="Date.times = false"
                      format="ampm"
                    ></v-time-picker> -->
                    <v-time-picker v-if="Date.times" v-model="Date.StartTime" full-width format="ampm">
                      <v-spacer></v-spacer>
                      <v-btn  color="primary" @click="Date.times = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        @click="Date.times = false"
                        >OK</v-btn
                      >
                    </v-time-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-menu
                    ref="Date.timee"
                    v-model="Date.timee"
                    :close-on-content-click="false"
                    :nudge-right="-110"
                    attach
                    :nudge-top="20"
                    :return-value.sync="EndTime"
                    transition="scale-transition"
                    offset-y
                    max-width="290px"
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="formattedStartTime(Date.EndTime)"
                        label="Time End"
                        append-icon="mdi-calendar-range-outline"
                        readonly
                        single-line
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <!-- <v-time-picker
                      v-if="Date.timee"
                      v-model="Date.EndTime"
                      full-width
                      @change="Date.timee = false"
                      format="ampm"
                    ></v-time-picker> -->
                    <v-time-picker v-if="Date.timee" v-model="Date.EndTime" full-width format="ampm">
                      <v-spacer></v-spacer>
                      <v-btn  color="primary" @click="Date.timee = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        color="primary"
                        @click="Date.timee = false"
                        >OK</v-btn
                      >
                    </v-time-picker>
                  </v-menu>
                </v-col>
              </v-row>
              <div class="d-flex justify-end" v-if="index > 0">
                <div>
                  <v-icon
                    class="red--text cursor_pointer"
                    @click="RemoveSeminarDatesTime(index)"
                    >mdi-delete-outline</v-icon
                  >
                </div>
              </div>
            </div>
            <div>
              <span
                class="primary--text"  style="cursor: pointer;"
                @click="AddSeminarDatesTime"
                >+ Add Next Day</span
              >
            </div>
            <!---------------End-------------Date time section---------------------------------------------->
            <div class="mt-6"><b>Other information</b></div>
            <v-textarea
              name="input-7-1"
              class="mb-5"
              label="Discount Note  (optional)"
              counter="1500"
              maxlength="1500"
              v-model="form.DiscountNote"
            ></v-textarea>
            <v-textarea
              name="input-7-1"
              class="mb-5"
              label="Other Info  (optional)"
              counter="3000"
              maxlength="3000"
              v-model="form.OtherNote"
            ></v-textarea>
            <div class="mt-6"><b>Waiver 1</b> <span>(optional)</span></div>
              <div class="py-8">
                <div class="d-flex">
                  <v-card class="mb-7" rounded="xl" flat>
                    <v-chip
                      color="primary"
                      @click:close="ChipWaiver1 = false"
                      close
                      outlined
                      v-show="ChipWaiver1"
                      pill
                      class="truncate-chip"
                    >
                      <span class="chip-text">{{ UploadedWaiver1fileName }}</span>
                    </v-chip>
                  </v-card>
                </div>

                <div>
                  <input
                    type="file"
                    class="d-none"
                    accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    ref="fileInputWaiver1"
                    @change="UpdateFileWaiver1"
                  />
                  <v-btn
                    color="primary"
                    style="background: white"
                    outlined
                    @click="UploadWaiver1"
                  >
                    <div class="text_transform">Upload Document</div>
                  </v-btn>
                </div>
              </div>
            <div class="mt-6"><b>Waiver 2</b> <span>(optional)</span></div>
            <div class="pt-8 pb-14">
              <div class="d-flex">
                <v-card class="mb-7" rounded="xl" flat>
                  <v-chip
                    color="primary"
                    @click:close="ChipWaiver2 = false"
                    close
                    outlined
                    v-show="ChipWaiver2"
                    pill
                    class="truncate-chip"
                  >
                    <span class="chip-text">{{ UploadedWaiver2fileName }}</span>
                  </v-chip>
                </v-card>
              </div>

              <div>
                <input
                  type="file"
                  class="d-none"
                  accept=".doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  ref="fileInputWaiver2"
                  @change="UpdateFileWaiver2"
                />
                <v-btn
                  color="primary"
                  style="background: white"
                  outlined
                  @click="UploadWaiver2"
                >
                  <div class="text_transform">Upload Document</div>
                </v-btn>
              </div>
            </div>
            <div class="d-flex align-center">
              <div class="d-flex align-items-center gap-3">
                <span>Is Parama Seminar?</span>
                <v-switch v-model="form.IsParamaSeminar" label=""></v-switch>
                <span v-if="form.IsParamaSeminar">On</span>
                <span v-else>Off</span>
              </div>
            </div>
            <div v-if="form.IsParamaSeminar" class="pb-4">
              <v-text-field
                label="Parama Offering ID"
                v-model="form.ParamaOfferingId"
                :error-messages="
                  getErrorMessageParamaOfferingID(form.ParamaOfferingId)
                "
              ></v-text-field>
              <v-text-field
                label="Parama Course ID"
                v-model="form.ParamaCourseId"
                :error-messages="
                  getErrorMessageParamaCourseId(form.ParamaCourseId)
                "
              ></v-text-field>
              <v-select
                class="my-4"
                label="Language"
                attach
                single-line
                persistent-hint
                :items="ParamaLanguages"
                item-text="value"
                item-value="id"
                dense
                v-model="form.ParamaLanguageId"
                :error-messages="
                  $v.form?.ParamaLanguageId?.$error ? 'Parama Language Id is required' : null
                "
              ></v-select>
            </div>
            <div class="pb-13" v-if="form.Type === 2">
              <v-text-field
                label="Zoom Link"
                v-model="form.ZoomLink"
                dense
                single-line
                hide-details
              ></v-text-field>
            </div>
          </div>
        </div>
      </div>
    </v-card>
    <v-card class="pa-5" flat>
      <div class="d-flex justify-end">
        <v-btn color="transparent" depressed class="" @click="close"
          ><span class="text_style">Cancel</span></v-btn
        >
        <v-btn
          class="px-14"
          depressed
          color="primary"
          :disabled="btnloader"
          @click="submit"
        >
          <span class="text_style" v-if="btnloader != true">Save</span>
          <v-progress-circular
            v-else
            indeterminate
            size="20"
            class="px-5"
            color="white"
            v-show="btnloader"
          ></v-progress-circular
        ></v-btn>
      </div>
    </v-card>
    <v-dialog v-model="InstructorRegisterDialog" max-width="650" persistent>
      <v-card class="pa-7">
        <div class="d-flex justify-end">
          <v-icon @click="InstructorRegisterDialog = false">mdi-close</v-icon>
        </div>
        <div class="d-flex justify-center" style="font-size: 1.5rem">
          <b>Thank you for registering</b>
        </div>
        <div class="d-flex justify-center">
          <v-card
            flat
            class="lightgrey my-5 grey--text"
            style="text-align: center"
            max-width="470"
          >
            You will receive an email confirming your registration for this
            course. Also an email has been sent to the instructor,
            [Instructor_name], and the coordinator, <br />
            [Coordinator_name].
          </v-card>
        </div>
        <div class="d-flex justify-center">
          <v-card
            flat
            class="lightgrey grey--text"
            style="text-align: center"
            max-width="470"
          >
            You may pay the instructor for the course now by clicking the link
            below. This link redirects to an external website not overseen by
            the IBA.
          </v-card>
        </div>
        <div class="d-flex justify-center">
          <v-checkbox
            v-model="form.PrimaryPaymentLink"
            value="RegisterInstructor"
          >
            <template v-slot:label>
              <div class="grey--text">
                Please first ensure you understand and agree to our
                <router-link to="/privacypolicy" class="link">
                  <span class="primary--text"><b>Privacy Policy.</b></span>
                </router-link>
              </div>
            </template>
          </v-checkbox>
        </div>
        <div class="d-flex justify-center">
          <v-btn
            color="primary"
            class="my-6 py-6 px-9"
            @click="InstructorRegisterDialog = false"
            depressed
          >
            <div class="text_transform">Seminar Payment</div>
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required,numeric } from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import moment from "moment-timezone";
export default {
  name: "editseminar",
  props: ["setDataEditSeminar", "InstructorsArray"],
  data() {
    return {
      btnloader:false,
      ParamaLanguages: [
        { id: 1, value: "English (US)" },
        { id: 2, value: "German" },
        { id: 3, value: "Portuguese" },
      ],
      InstructorRegisterDialog: false,
      courseId: null,
      Waiver1FileArray: null,
      ChipWaiver1: this.setDataEditSeminar.WaiverOne != null ? true : false,
      UploadedWaiver1fileName:
        this.setDataEditSeminar.WaiverOne != null
          ? this.setDataEditSeminar.WaiverOne.slice(52)
          : "",
      Waiver2FileArray: null,
      ChipWaiver2: this.setDataEditSeminar.WaiverTwo != null ? true : false,
      UploadedWaiver2fileName:
        this.setDataEditSeminar.WaiverTwo != null
          ? this.setDataEditSeminar.WaiverTwo.slice(52)
          : "",
      DivSeminarDateTime: 0,
      DivsSeminarDateTime: [],
      StatusArray: ["Active", "Inactive"],
      Locations: [
        { location: "Location 1", Id: 1 },
        { location: "Location 2", Id: 2 },
      ],
      filterLanguageList: [
        "English",
        "French",
        "German",
        "Japanese",
        "Czech",
        "Dutch",
        "Danish",
        "Italian",
        "Portuguese",
        "Filipino",
        "Spanish",
        "Chinese",
        "Russian",
      ],
      // timeZoneList: [
      //   {
      //     name: "(GMT-11:00) Midway Island",
      //     timezone: "Pacific/Midway",
      //   },
      //   {
      //     name: "(GMT-11:00) Samoa",
      //     timezone: "US/Samoa",
      //   },
      //   {
      //     name: "(GMT-10:00) Hawaii",
      //     timezone: "US/Hawaii",
      //   },
      //   {
      //     name: "(GMT-09:00) Alaska",
      //     timezone: "US/Alaska",
      //   },
      //   {
      //     name: "(GMT-08:00) Pacific Time (US & Canada)",
      //     timezone: "US/Pacific",
      //   },
      //   {
      //     name: "(GMT-08:00) Tijuana",
      //     timezone: "America/Tijuana",
      //   },
      //   {
      //     name: "(GMT-07:00) Arizona",
      //     timezone: "US/Arizona",
      //   },
      //   {
      //     name: "(GMT-07:00) Mountain Time (US & Canada)",
      //     timezone: "US/Mountain",
      //   },
      //   {
      //     name: "(GMT-07:00) Chihuahua",
      //     timezone: "America/Chihuahua",
      //   },
      //   {
      //     name: "(GMT-07:00) Mazatlan",
      //     timezone: "America/Mazatlan",
      //   },
      //   {
      //     name: "(GMT-06:00) Mexico City",
      //     timezone: "America/Mexico_City",
      //   },
      //   {
      //     name: "(GMT-06:00) Monterrey",
      //     timezone: "America/Monterrey",
      //   },
      //   {
      //     name: "(GMT-06:00) Saskatchewan",
      //     timezone: "Canada/Saskatchewan",
      //   },
      //   {
      //     name: "(GMT-06:00) Central Time (US & Canada)",
      //     timezone: "US/Central",
      //   },
      //   {
      //     name: "(GMT-05:00) Eastern Time (US & Canada)",
      //     timezone: "US/Eastern",
      //   },
      //   {
      //     name: "(GMT-05:00) Indiana (East)",
      //     timezone: "US/East-Indiana",
      //   },
      //   {
      //     name: "(GMT-05:00) Bogota",
      //     timezone: "America/Bogota",
      //   },
      //   {
      //     name: "(GMT-05:00) Lima",
      //     timezone: "America/Lima",
      //   },
      //   {
      //     name: "(GMT-04:30) Caracas",
      //     timezone: "America/Caracas",
      //   },
      //   {
      //     name: "(GMT-04:00) Atlantic Time (Canada)",
      //     timezone: "Canada/Atlantic",
      //   },
      //   {
      //     name: "(GMT-04:00) La Paz",
      //     timezone: "America/La_Paz",
      //   },
      //   {
      //     name: "(GMT-04:00) Santiago",
      //     timezone: "America/Santiago",
      //   },
      //   {
      //     name: "(GMT-03:30) Newfoundland",
      //     timezone: "Canada/Newfoundland",
      //   },
      //   {
      //     name: "(GMT-03:00) Buenos Aires",
      //     timezone: "America/Buenos_Aires",
      //   },
      //   {
      //     name: "(GMT-03:00) Greenland",
      //     timezone: "Greenland",
      //   },
      //   {
      //     name: "(GMT-02:00) Stanley",
      //     timezone: "Atlantic/Stanley",
      //   },
      //   {
      //     name: "(GMT-01:00) Azores",
      //     timezone: "Atlantic/Azores",
      //   },
      //   {
      //     name: "(GMT-01:00) Cape Verde Is.",
      //     timezone: "Atlantic/Cape_Verde",
      //   },
      //   {
      //     name: "(GMT) Casablanca",
      //     timezone: "Africa/Casablanca",
      //   },
      //   {
      //     name: "(GMT) Dublin",
      //     timezone: "Europe/Dublin",
      //   },
      //   {
      //     name: "(GMT) Lisbon",
      //     timezone: "Europe/Lisbon",
      //   },
      //   {
      //     name: "(GMT) London",
      //     timezone: "Europe/London",
      //   },
      //   {
      //     name: "(GMT) Monrovia",
      //     timezone: "Africa/Monrovia",
      //   },
      //   {
      //     name: "(GMT+01:00) Amsterdam",
      //     timezone: "Europe/Amsterdam",
      //   },
      //   {
      //     name: "(GMT+01:00) Belgrade",
      //     timezone: "Europe/Belgrade",
      //   },
      //   {
      //     name: "(GMT+01:00) Berlin",
      //     timezone: "Europe/Berlin",
      //   },
      //   {
      //     name: "(GMT+01:00) Bratislava",
      //     timezone: "Europe/Bratislava",
      //   },
      //   {
      //     name: "(GMT+01:00) Brussels",
      //     timezone: "Europe/Brussels",
      //   },
      //   {
      //     name: "(GMT+01:00) Budapest",
      //     timezone: "Europe/Budapest",
      //   },
      //   {
      //     name: "(GMT+01:00) Copenhagen",
      //     timezone: "Europe/Copenhagen",
      //   },
      //   {
      //     name: "(GMT+01:00) Ljubljana",
      //     timezone: "Europe/Ljubljana",
      //   },
      //   {
      //     name: "(GMT+01:00) Madrid",
      //     timezone: "Europe/Madrid",
      //   },
      //   {
      //     name: "(GMT+01:00) Paris",
      //     timezone: "Europe/Paris",
      //   },
      //   {
      //     name: "(GMT+01:00) Prague",
      //     timezone: "Europe/Prague",
      //   },
      //   {
      //     name: "(GMT+01:00) Rome",
      //     timezone: "Europe/Rome",
      //   },
      //   {
      //     name: "(GMT+01:00) Sarajevo",
      //     timezone: "Europe/Sarajevo",
      //   },
      //   {
      //     name: "(GMT+01:00) Skopje",
      //     timezone: "Europe/Skopje",
      //   },
      //   {
      //     name: "(GMT+01:00) Stockholm",
      //     timezone: "Europe/Stockholm",
      //   },
      //   {
      //     name: "(GMT+01:00) Vienna",
      //     timezone: "Europe/Vienna",
      //   },
      //   {
      //     name: "(GMT+01:00) Warsaw",
      //     timezone: "Europe/Warsaw",
      //   },
      //   {
      //     name: "(GMT+01:00) Zagreb",
      //     timezone: "Europe/Zagreb",
      //   },
      //   {
      //     name: "(GMT+02:00) Athens",
      //     timezone: "Europe/Athens",
      //   },
      //   {
      //     name: "(GMT+02:00) Bucharest",
      //     timezone: "Europe/Bucharest",
      //   },
      //   {
      //     name: "(GMT+02:00) Cairo",
      //     timezone: "Africa/Cairo",
      //   },
      //   {
      //     name: "(GMT+02:00) Harare",
      //     timezone: "Africa/Harare",
      //   },
      //   {
      //     name: "(GMT+02:00) Helsinki",
      //     timezone: "Europe/Helsinki",
      //   },
      //   {
      //     name: "(GMT+02:00) Istanbul",
      //     timezone: "Europe/Istanbul",
      //   },
      //   {
      //     name: "(GMT+02:00) Jerusalem",
      //     timezone: "Asia/Jerusalem",
      //   },
      //   {
      //     name: "(GMT+02:00) Kyiv",
      //     timezone: "Europe/Kiev",
      //   },
      //   {
      //     name: "(GMT+02:00) Minsk",
      //     timezone: "Europe/Minsk",
      //   },
      //   {
      //     name: "(GMT+02:00) Riga",
      //     timezone: "Europe/Riga",
      //   },
      //   {
      //     name: "(GMT+02:00) Sofia",
      //     timezone: "Europe/Sofia",
      //   },
      //   {
      //     name: "(GMT+02:00) Tallinn",
      //     timezone: "Europe/Tallinn",
      //   },
      //   {
      //     name: "(GMT+02:00) Vilnius",
      //     timezone: "Europe/Vilnius",
      //   },
      //   {
      //     name: "(GMT+03:00) Baghdad",
      //     timezone: "Asia/Baghdad",
      //   },
      //   {
      //     name: "(GMT+03:00) Kuwait",
      //     timezone: "Asia/Kuwait",
      //   },
      //   {
      //     name: "(GMT+03:00) Nairobi",
      //     timezone: "Africa/Nairobi",
      //   },
      //   {
      //     name: "(GMT+03:00) Riyadh",
      //     timezone: "Asia/Riyadh",
      //   },
      //   {
      //     name: "(GMT+03:00) Moscow",
      //     timezone: "Europe/Moscow",
      //   },
      //   {
      //     name: "(GMT+03:30) Tehran",
      //     timezone: "Asia/Tehran",
      //   },
      //   {
      //     name: "(GMT+04:00) Baku",
      //     timezone: "Asia/Baku",
      //   },
      //   {
      //     name: "(GMT+04:00) Volgograd",
      //     timezone: "Europe/Volgograd",
      //   },
      //   {
      //     name: "(GMT+04:00) Muscat",
      //     timezone: "Asia/Muscat",
      //   },
      //   {
      //     name: "(GMT+04:00) Tbilisi",
      //     timezone: "Asia/Tbilisi",
      //   },
      //   {
      //     name: "(GMT+04:00) Yerevan",
      //     timezone: "Asia/Yerevan",
      //   },
      //   {
      //     name: "(GMT+04:30) Kabul",
      //     timezone: "Asia/Kabul",
      //   },
      //   {
      //     name: "(GMT+05:00) Karachi",
      //     timezone: "Asia/Karachi",
      //   },
      //   {
      //     name: "(GMT+05:00) Tashkent",
      //     timezone: "Asia/Tashkent",
      //   },
      //   {
      //     name: "(GMT+05:30) Kolkata",
      //     timezone: "Asia/Kolkata",
      //   },
      //   {
      //     name: "(GMT+05:45) Kathmandu",
      //     timezone: "Asia/Kathmandu",
      //   },
      //   {
      //     name: "(GMT+06:00) Ekaterinburg",
      //     timezone: "Asia/Yekaterinburg",
      //   },
      //   {
      //     name: "(GMT+06:00) Almaty",
      //     timezone: "Asia/Almaty",
      //   },
      //   {
      //     name: "(GMT+06:00) Dhaka",
      //     timezone: "Asia/Dhaka",
      //   },
      //   {
      //     name: "(GMT+07:00) Novosibirsk",
      //     timezone: "Asia/Novosibirsk",
      //   },
      //   {
      //     name: "(GMT+07:00) Bangkok",
      //     timezone: "Asia/Bangkok",
      //   },
      //   {
      //     name: "(GMT+07:00) Jakarta",
      //     timezone: "Asia/Jakarta",
      //   },
      //   {
      //     name: "(GMT+08:00) Krasnoyarsk",
      //     timezone: "Asia/Krasnoyarsk",
      //   },
      //   {
      //     name: "(GMT+08:00) Chongqing",
      //     timezone: "Asia/Chongqing",
      //   },
      //   {
      //     name: "(GMT+08:00) Hong Kong",
      //     timezone: "Asia/Hong_Kong",
      //   },
      //   {
      //     name: "(GMT+08:00) Kuala Lumpur",
      //     timezone: "Asia/Kuala_Lumpur",
      //   },
      //   {
      //     name: "(GMT+08:00) Perth",
      //     timezone: "Australia/Perth",
      //   },
      //   {
      //     name: "(GMT+08:00) Singapore",
      //     timezone: "Asia/Singapore",
      //   },
      //   {
      //     name: "(GMT+08:00) Taipei",
      //     timezone: "Asia/Taipei",
      //   },
      //   {
      //     name: "(GMT+08:00) Ulaan Bataar",
      //     timezone: "Asia/Ulaanbaatar",
      //   },
      //   {
      //     name: "(GMT+08:00) Urumqi",
      //     timezone: "Asia/Urumqi",
      //   },
      //   {
      //     name: "(GMT+09:00) Irkutsk",
      //     timezone: "Asia/Irkutsk",
      //   },
      //   {
      //     name: "(GMT+09:00) Seoul",
      //     timezone: "Asia/Seoul",
      //   },
      //   {
      //     name: "(GMT+09:00) Tokyo",
      //     timezone: "Asia/Tokyo",
      //   },
      //   {
      //     name: "(GMT+09:30) Adelaide",
      //     timezone: "Australia/Adelaide",
      //   },
      //   {
      //     name: "(GMT+09:30) Darwin",
      //     timezone: "Australia/Darwin",
      //   },
      //   {
      //     name: "(GMT+10:00) Yakutsk",
      //     timezone: "Asia/Yakutsk",
      //   },
      //   {
      //     name: "(GMT+10:00) Brisbane",
      //     timezone: "Australia/Brisbane",
      //   },
      //   {
      //     name: "(GMT+10:00) Canberra",
      //     timezone: "Australia/Canberra",
      //   },
      //   {
      //     name: "(GMT+10:00) Guam",
      //     timezone: "Pacific/Guam",
      //   },
      //   {
      //     name: "(GMT+10:00) Hobart",
      //     timezone: "Australia/Hobart",
      //   },
      //   {
      //     name: "(GMT+10:00) Melbourne",
      //     timezone: "Australia/Melbourne",
      //   },
      //   {
      //     name: "(GMT+10:00) Port Moresby",
      //     timezone: "Pacific/Port_Moresby",
      //   },
      //   {
      //     name: "(GMT+10:00) Sydney",
      //     timezone: "Australia/Sydney",
      //   },
      //   {
      //     name: "(GMT+11:00) Vladivostok",
      //     timezone: "Asia/Vladivostok",
      //   },
      //   {
      //     name: "(GMT+12:00) Magadan",
      //     timezone: "Asia/Magadan",
      //   },
      //   {
      //     name: "(GMT+12:00) Auckland",
      //     timezone: "Pacific/Auckland",
      //   },
      //   {
      //     name: "(GMT+12:00) Fiji",
      //     timezone: "Pacific/Fiji",
      //   },
      // ],
      AllTimeZone: moment.tz.names().map((tz) => ({
        name: `(UTC${moment.tz(tz).format('Z')}) ${tz.replace('_', ' ')}`,
        timezone: tz,
      })),
      checkbox: [],
      Modality: [],
      ModalityList: [],
      showmonitorRadio: false,
      AutoGraduateRadio: false,
      IbaPaymentRadio: false,
      showmonitorRadio1: false,
      AutoGraduateRadio1: false,
      IbaPaymentRadio1: false,
      CalanderEarlyBirdEndTime: false,
      form: {
        IsParamaSeminar: this.setDataEditSeminar?.IsParamaSeminar,
        ParamaOfferingId: this.setDataEditSeminar?.paramaSeminar?.ParamaOfferingId,
        ParamaCourseId: this.setDataEditSeminar?.paramaSeminar?.ParamaCourseId,
        ParamaLanguageId: this.setDataEditSeminar?.paramaSeminar?.ParamaLanguageId,
        InstructorId: this.setDataEditSeminar?.Instructor?.Id,
        Type: this.setDataEditSeminar.Type,
        CourseId: this.setDataEditSeminar?.Course.Id,
        CoordinatorId: this.setDataEditSeminar?.Coordinator?.Id,
        Location: this.setDataEditSeminar?.Location?.Id,
        Timezone: this.setDataEditSeminar.Timezone,
        Languages: this.setDataEditSeminar.Languages,
        Status: this.setDataEditSeminar.Status,
        AvailableOnline: this.setDataEditSeminar.AvailableOnline,
        ZoomLink: this.setDataEditSeminar.ZoomLink,
        FullPrice: this.setDataEditSeminar.SeminarPayment.FullPrice,
        CurrencyId: this.setDataEditSeminar.SeminarPayment.CurrencyId,
        EarlyBirdPrice: this.setDataEditSeminar.SeminarPayment.EarlyBirdPrice,
        EarlyBirdEndTime:
          this.setDataEditSeminar.SeminarPayment.EarlyBirdEndTime?.split("T")[0],
        MonitorRate: this.setDataEditSeminar.SeminarPayment.MonitorRate,
        AutoPayment: this.setDataEditSeminar.SeminarPayment.AutoPayment,
        IbaPayment: this.setDataEditSeminar.SeminarPayment.IbaPayment,
        PaymentLink: this.setDataEditSeminar.SeminarPayment.PaymentLink,
        DiscountNote: this.setDataEditSeminar.DiscountNote,
        OtherNote: this.setDataEditSeminar.OtherNote,
        WaiverOne: this.setDataEditSeminar.WaiverOne,
        WaiverTwo: this.setDataEditSeminar.WaiverTwo,
        EarlyBirdPaymentLink:
          this.setDataEditSeminar.SeminarPayment.EarlyBirdPaymentLink,
        RepeatStandardStudentPaymentLink:
          this.setDataEditSeminar.SeminarPayment.RepeatStandardStudentPaymentLink,
        RepeatPractitionerStudentPaymentLink:
          this.setDataEditSeminar.SeminarPayment.RepeatPractitionerStudentPaymentLink,
        PrimaryPaymentLink:
          this.setDataEditSeminar.SeminarPayment.PrimaryPaymentLink,
        SeminarDates: [
          {
            dated: false,
            times: false,
            timee: false,
            Date: null,
            StartTime: null,
            EndTime: null,
          },
        ],
      },
      items: [],
      Presential: false,

      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      dateAt: false,
      StartTime: null,
      time1: false,
      EndTime: null,
      time2: false,
    };
  },
  validations: {
    form: {
      FullPrice: {
        required,
        numeric,
      },
      EarlyBirdPrice: {
        numeric,
        greaterThanFullPrice(value1) {
          return parseInt(value1) < parseInt(this.form.FullPrice);
        },
      },
      PrimaryPaymentLink: {},
      RepeatStandardStudentPaymentLink: {
        requiresPrimaryLink(value) {
          return !value || this.form.PrimaryPaymentLink;
        }
      },
      RepeatPractitionerStudentPaymentLink: {
        requiresPrimaryLink(value) {
          return !value || this.form.PrimaryPaymentLink;
        }
      },
      EarlyBirdPaymentLink: {
        requiresPrimaryLink(value) {
          return !value || this.form.PrimaryPaymentLink;
        }
      },
      ParamaOfferingId: {
        required,
      },
      ParamaCourseId: {
        required,
      },
      ParamaLanguageId: {
        required,
      },
    },
  },

  // computed: {
  //   ...mapGetters([
  //     "GetTimeZone",
  //     "GetCourses",
  //     "GetLoggedInUser",
  //     "GetCurrencies",
  //   ]),
  // },
  // mounted() {
  //   this.$store.dispatch("GetCurrencies");
  //   this.$store
  //       .dispatch("GetCourse")
  //   this.CourseFromCoursesPage();
  // },
  computed: {
    ...mapGetters([
      // "GetTimeZone",
      "GetCoursesIDsAndTitle",
      "GetLoggedInUser",
      "GetCurrencies",
      "GetLocation",
      "GetCoordinators",
    ]),
    acceptedInstructorsCoordinator() {
      return this.GetCoordinators.filter((instructor) => {
        if (instructor.HasAccepted) {
          instructor.Coordinator.fullName = `${instructor.Coordinator.FirstName} ${instructor.Coordinator.LastName}`;
          return true;
        }
        return false;
      });
    },
    visibleCourses() {
      return this.GetCoursesIDsAndTitle.filter(course => course.Visibility);
    },
  },
  mounted() {
    this.getLocations(this.form.InstructorId);
    this.$store.dispatch("GetCurrencies");
    // this.$store.dispatch("GetCourse");
    this.CourseFromCoursesPage();
    this.setDateAndTime();
  },
  updated() {
    if (this.ChipWaiver1 == false) {
      this.UploadedWaiver1fileName = "";
      this.form.WaiverOne = "";
    }
    if (this.ChipWaiver2 == false) {
      this.UploadedWaiver2fileName = "";
      this.form.WaiverTwo = "";
    }
  },
  methods: {
    customFilter(item, queryText, itemText) {
      const text = itemText.toLowerCase();
      const searchText = queryText.toLowerCase();
      return text.includes(searchText) || item.timezone.toLowerCase().includes(searchText);
    },
    formattedStartTime(startTime) {
      if (!startTime) return "";
      const [hours, minutes] = startTime.split(":");
      const date = new Date(2000, 0, 1, parseInt(hours), parseInt(minutes));
      const formatted = date.toLocaleTimeString([], {
        hour: "numeric",
        minute: "2-digit",
        hour12: true,
      });
      return formatted.replace(/(\d+:\d+)\s([APMapm]{2})/, "$1 $2");
    },
    getErrorMessagesEarlyBirdPrice(field) {
      if(this.form.FullPrice == 0 && this.form.FullPrice !== ''){
        this.form.EarlyBirdPrice = ""
        this.form.EarlyBirdEndTime = ""
      }
      if (
        parseInt(field) >= parseInt(this.form.FullPrice) &&
        this.form.FullPrice != null
      ) {
        return "Early Bird Price should be less than Full Price";
      }
      if (this.$v.form?.EarlyBirdPrice?.$error == false) {
        return null;
      }
      if (field?.includes(".")) {
        return "Early Bird Price must be whole number";
      }
      
      return null;
    },
    getErrorMessagesFullPrice(field) {
      if (this.$v.form?.FullPrice?.$error == false) {
        return null;
      }
      if (field?.includes(".")) {
        return "Course Price must be whole number";
      }
      if (field == null || field == "") {
        return "Course Price is required";
      }
      return null;
    },
    getErrorMessageParamaOfferingID(field) {
      if (!this.$v.form?.ParamaOfferingId?.$error) return null;
      if (!field) {
        return "Parama Offering ID is required";
      }
      return null;
    },
    getErrorMessageParamaCourseId(field) {
      if (!this.$v.form?.ParamaCourseId?.$error) return null;
      if (!field) {
        return "Parama Course ID is required";
      }
      return null;
    },
    setDateAndTime() {
      let timezone;
      if (this.form.Type === 1 && this.form.Location) {
        const selectedLoc = this.GetLocation?.List?.find(loc => loc.Id === this.form.Location);
        timezone = selectedLoc?.TimeZone || moment.tz.guess();
      } else if (this.form.Type === 2 && this.form.Timezone) {
        timezone = this.form.Timezone;
      } else {
        timezone = this.setDataEditSeminar.Timezone || 
                  (this.setDataEditSeminar.Location?.TimeZone) || 
                  moment.tz.guess();
      }
      for (let index = 0; index < this.setDataEditSeminar.SeminarDateAndTimes.length; index++) {
        if (index >= this.form.SeminarDates.length) {
          this.form.SeminarDates.push({
            dated: false,
            times: false,
            timee: false,
            Date: null,
            StartTime: null,
            EndTime: null,
          });
        }
        
        // Convert UTC times back to the selected timezone
        const utcStartTime = moment.utc(this.setDataEditSeminar.SeminarDateAndTimes[index].StartTime);
        const utcEndTime = moment.utc(this.setDataEditSeminar.SeminarDateAndTimes[index].EndTime);
        
        // Convert to the seminar's timezone
        const localStartTime = utcStartTime.tz(timezone);
        const localEndTime = utcEndTime.tz(timezone);
        
        // Set the form values in the selected timezone
        this.form.SeminarDates[index].Date = localStartTime.format("YYYY-MM-DD");
        this.form.SeminarDates[index].StartTime = localStartTime.format("HH:mm");
        this.form.SeminarDates[index].EndTime = localEndTime.format("HH:mm");
      }
      
      // Remove any extra dates if needed
      if (this.form.SeminarDates.length > this.setDataEditSeminar.SeminarDateAndTimes.length) {
        this.form.SeminarDates = this.form.SeminarDates.slice(0, this.setDataEditSeminar.SeminarDateAndTimes.length);
      }
    },
    getLocations(id) {
      const obj = {
        page: 1,
        userId: id,
        pageSize: "all",
        search: "",
        filters: "",
      };
      this.$store.dispatch("GetLocation", obj);
      this.fetchData(id);
    },
    fetchData(instructorId) {
      var obj = {
        page: 1,
        pageSize: "All",
        instructorId: instructorId,
      };
      this.$store.dispatch("GetCoordinator", obj);
    },

    CourseFromCoursesPage() {
      if (this.$route.query.courseId !== undefined) {
        this.courseId = this.$route.query.courseId;
        this.form.CourseId = Number(this.courseId);
      }
    },
    UpdateFileWaiver1(e) {
      this.ChipWaiver1 = true;
      this.form.WaiverOne = e.target.files[0];

      this.UploadedWaiver1fileName = this.form.WaiverOne.name;
    },
    UploadWaiver1() {
      this.$refs.fileInputWaiver1.click();
    },
    UpdateFileWaiver2(e) {
      this.ChipWaiver2 = true;
      this.form.WaiverTwo = e.target.files[0];
      this.UploadedWaiver2fileName = this.form.WaiverTwo.name;
    },
    UploadWaiver2() {
      this.$refs.fileInputWaiver2.click();
    },
     AddSeminarDatesTime() {
      const lastDateIndex = this.form.SeminarDates.length - 1;
      const lastDate = this.form.SeminarDates[lastDateIndex];
      let newDate = '';
      let newStartTime = null;
      let newEndTime = null;

      if (lastDate && lastDate.Date && lastDate.StartTime && lastDate.EndTime) {
        // Use moment.js for timezone-safe date calculation
        newDate = moment(lastDate.Date).add(1, 'days').format('YYYY-MM-DD');
        newStartTime = lastDate.StartTime;
        newEndTime = lastDate.EndTime;
      }
      this.form.SeminarDates.push({
        Date: newDate,
        StartTime: newStartTime,
        EndTime: newEndTime,
        dated: false,
        times: false,
        timee: false,
      });
    },
    formatDate(date) {
      if (!date) return '';
      const d = new Date(date);
      const month = '' + (d.getMonth() + 1);
      const day = '' + d.getDate();
      const year = d.getFullYear();
      return [year, month.padStart(2, '0'), day.padStart(2, '0')].join('-');
    },
    RemoveSeminarDatesTime(index) {
      this.form.SeminarDates = this.form.SeminarDates.filter((x, i) => {
        if (i !== index) {
          return x;
        }
      });
    },
    close() {
      this.$emit("close");
    },
    submit() {
      this.$v.form.FullPrice.$touch();
      this.$v.form.EarlyBirdPrice.$touch();
      this.$v.form.RepeatStandardStudentPaymentLink.$touch();
      this.$v.form.RepeatPractitionerStudentPaymentLink.$touch();
      this.$v.form.EarlyBirdPaymentLink.$touch();
      if (this.form.IsParamaSeminar) {
        this.$v.form.ParamaOfferingId.$touch();
        this.$v.form.ParamaCourseId.$touch();
        this.$v.form.ParamaLanguageId.$touch();
      }
      if (this.$v.form.FullPrice.$invalid || this.$v.form.RepeatStandardStudentPaymentLink.$invalid || this.$v.form.RepeatPractitionerStudentPaymentLink.$invalid || this.$v.form.EarlyBirdPaymentLink.$invalid || (this.form.EarlyBirdPrice && this.$v.form.EarlyBirdPrice.$invalid) || (this.form.IsParamaSeminar && (this.$v.form.ParamaOfferingId.$invalid || this.$v.form.ParamaCourseId.$invalid || this.$v.form.ParamaLanguageId.$invalid))) {
        return;
      } else {
        this.btnloader = true;
        const form = new FormData();
        form.append("Id", this.setDataEditSeminar.Id);
        form.append("Type", this.form.Type);
        form.append("CourseId", this.form.CourseId);
        form.append("InstructorId", this.form.InstructorId);
        form.append("CoordinatorId", this.form.CoordinatorId);
        form.append("LocationId", this.form.Type == 1 ? this.form.Location : '');
        form.append("Timezone", this.form.Type == 2 ? this.form.Timezone : '');
        form.append("Languages", this.form.Languages);
        form.append("Status", this.form.Status);
        form.append("AvailableOnline", this.form.AvailableOnline);
        form.append("IsParamaSeminar", this.form.IsParamaSeminar);
        if(this.form.IsParamaSeminar){
          form.append("ParamaOfferingId", this.form.ParamaOfferingId);
          form.append("ParamaCourseId", this.form.ParamaCourseId);
          form.append("ParamaLanguageId", this.form.ParamaLanguageId);
        }
        form.append("ZoomLink", this.form.ZoomLink == null ? "" : this.form.ZoomLink);
        form.append("DiscountNote", this.form.DiscountNote == null ? "" : this.form.DiscountNote);
        form.append("OtherNote", this.form.OtherNote == null ? "" : this.form.OtherNote);
        form.append("SeminarPayment.FullPrice", this.form.FullPrice);
        form.append("SeminarPayment.CurrencyId", this.form.CurrencyId);
        form.append("SeminarPayment.EarlyBirdPrice", this.form.EarlyBirdPrice || '');
        form.append(
          "SeminarPayment.EarlyBirdEndTime",
          this.form.EarlyBirdEndTime || ''
        );
        form.append("SeminarPayment.MonitorRate", this.form.MonitorRate);
        form.append(
          "SeminarPayment.EarlyBirdPaymentLink",
          this.form.EarlyBirdPaymentLink == null ? "" : this.form.EarlyBirdPaymentLink
        );
        form.append(
          "SeminarPayment.RepeatStandardStudentPaymentLink",
          this.form.RepeatStandardStudentPaymentLink == null ? "" : this.form.RepeatStandardStudentPaymentLink
        );
        form.append(
          "SeminarPayment.RepeatPractitionerStudentPaymentLink",
          this.form.RepeatPractitionerStudentPaymentLink == null ? "" : this.form.RepeatPractitionerStudentPaymentLink
        );
        form.append(
          "SeminarPayment.PrimaryPaymentLink",
          this.form.PrimaryPaymentLink == null ? "" : this.form.PrimaryPaymentLink
        );
        form.append("SeminarPayment.AutoPayment", this.form.AutoPayment);
        form.append("SeminarPayment.IbaPayment", this.form.IbaPayment);
        form.append("SeminarPayment.PaymentLink", this.form.PaymentLink == null ? "" : this.form.PaymentLink);
        form.append("WaiverOne", this.form.WaiverOne);
        form.append("WaiverTwo", this.form.WaiverTwo);
        this.form.SeminarDates.forEach((x, i) => {
          let timezone;
          if (this.form.Type === 1 && this.form.Location) {
            const selectedLoc = this.GetLocation?.List?.find(loc => loc.Id === this.form.Location);
            timezone = selectedLoc?.TimeZone || moment.tz.guess();
          } else if (this.form.Type === 2 && this.form.Timezone) {
            timezone = this.form.Timezone;
          } else {
            timezone = moment.tz.guess();
          }

          const startDateTimeUTC = moment.tz(
            `${x.Date} ${x.StartTime}`, 
            "YYYY-MM-DD HH:mm", 
            timezone
          ).utc();
          
          const endDateTimeUTC = moment.tz(
            `${x.Date} ${x.EndTime}`, 
            "YYYY-MM-DD HH:mm", 
            timezone
          ).utc();
          form.append(`SeminarDateTimes[${i}].Date`, startDateTimeUTC.format("YYYY-MM-DD HH:mm:ss"));
          form.append(
            `SeminarDateTimes[${i}].StartTime`,
            startDateTimeUTC.format("YYYY-MM-DD HH:mm:ss")
          );
          form.append(
            `SeminarDateTimes[${i}].EndTime`,
            endDateTimeUTC.format("YYYY-MM-DD HH:mm:ss")
          );
        });
        this.$store.dispatch("EditSeminar", form).then((res) => {
          if (res.Status) {
            this.btnloader = false;
            this.close();
            this.$swal.fire({
              toast: true,
              position: "top-end",
              icon: "success",
              title: "Edited Successfully",
              showConfirmButton: false,
              timer: 1500,
            });
          }
        });
      }
    },
  },
  watch: {
    // Watch for location changes (in-person case)
    'form.Location': {
      handler() {
        // This will trigger the computed property to update
        this.$forceUpdate();
      },
      immediate: true
    },
    // Watch for timezone changes (online case)
    'form.Timezone': {
      handler() {
        // This will trigger the computed property to update
        this.$forceUpdate();
      },
      immediate: true
    },
    // Watch for type changes (switching between in-person and online)
    'form.Type': {
      handler() {
        // This will trigger the computed property to update
        this.$forceUpdate();
      },
      immediate: true
    },
    'form.SeminarDates': {
      deep: true,
      handler() {
        // Force update when any date/time changes
        this.$forceUpdate();
      }
    }
  },
};
</script>

<style scoped>
.slide-toggle {
  position: relative;
  background-color: #e2e3ed;
  border-radius: 200px;
  width: 100%;
  margin: auto;
}
.boxes {
  width: 50%;
  height: 47px;
  position: relative;
  z-index: 2;
  display: flex;
  justify-content: space-around;
  align-items: center;
  cursor: pointer;
  text-align: center;
  border-radius: 200px;
}
.box-active {
  position: absolute;
  width: 50%;
  height: 41px;
  top: 3px;
  left: 1%;
  right: 0;
  z-index: 1;
  background-color: white;

  border-radius: 200px;
}

.presential-active {
  right: 0;
  left: 49% !important;
}
.truncate-chip {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  overflow: hidden;
}

.chip-text {
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  margin-right: 8px;
}

</style>
